<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Nome</label>
                <input
                  class="form-control"
                  name="name"
                  type="text"
                  v-model="form.name"
                  :class="{
                    'is-invalid': submitted && $v.form.name.$error
                  }"
                >
                <div
                  v-if="submitted && !$v.form.name.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveItem()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    idTemplate: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo tipo de anexo',
      loading: true,
      fullPage: true,
      submitted: false,
      template: {},
      form: {},
      modal: false
    }
  },
  validations () {
    let valid = {
      name: { required }
    }
    return { form: valid }
  },
  mounted () {
  },
  methods: {
    ...mapActions('statusPends', {
      getAttachment: 'show',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Tipo de Anexo'
        this.getAttachment(id).then((data) => {
          console.log(this.data)
          this.form = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveItem () {
      this.submitted = true
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        window.scroll(0, 0)
        return
      }

      // if (!this.$refs.header_banner.files[0] && this.showHeader) {
      //   errorMessage('Alerta: Você precisa anexar uma imagem')
      //   return
      // }
      this.loading = true

      await this.postData(this.form).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.form = {}
        this.$v.$reset()
        this.loading = false
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.form = {}
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('statusPends', { data: 'statusPend' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
